import type { ModelConfig } from 'types/models-config';
import { ucdCampaigns as ucdLinkData } from 'omega-rtc/links';
import UCDHomePage from 'omega-rtc/views/ucd/UCDHomePage';
import UCDCreateSmartCommsCampaign from 'omega-rtc/views/ucd/UCDCreateSmartCommsCampaign';
import UCDSmartCommsCampaignDetailPage from 'omega-rtc/views/ucd/UCDSmartCommsCampaignDetailPage';
import ProjectEditPage from 'omega-rtc/views/ucd/ProjectEditPage';
import ProjectDetailPage from 'omega-rtc/views/ucd/ProjectDetailPage';
import CampaignEditPage from 'omega-rtc/views/ucd/CampaignEditPage';
import CampaignDetailPage from 'omega-rtc/views/ucd/CampaignDetailPage';
import CreateTridentCampaignPage from 'omega-rtc/views/ucd/trident/CreateTridentCampaign';
import EditTridentCampaignPage from 'omega-rtc/views/ucd/trident/EditTridentCampaign';
import CreateJourneyCampaignPage from 'omega-rtc/views/ucd/trident/CreateJourneyCampaign';
import CreateJourneyCampaignGroup from 'omega-rtc/views/ucd/CreateJourneyCampaignGroup';
import EditJourneyCampaignGroup from 'omega-rtc/views/ucd/EditJourneyCampaignGroup';
import JourneyCampaignDetailPage from 'omega-rtc/views/ucd/JourneyCampaignDetailPage';
import JourneyCampaignEditPage from 'omega-rtc/views/ucd/JourneyCampaignEditPage';
import JourneyCampaignGroupViewPage from 'omega-rtc/views/ucd/JourneyCampaignGroupViewPage';
import { UCD_ROUTES_LINK } from 'omega-rtc/constants/ucd';

const { localeSelector, permissionKey, webPath, hasFieldsAccessFunc } =
  ucdLinkData;

const {
  CAMPAIGN_EDIT,
  CAMPAIGN_VIEW,
  JOURNEY_CAMPAIGN_CREATE,
  JOURNEY_CAMPAIGN_BUILDER_EDIT,
  JOURNEY_CAMPAIGN_EDIT,
  JOURNEY_CAMPAIGN_VIEW,
  JOURNEY_CAMPAIGN_GROUP_CREATE,
  JOURNEY_CAMPAIGN_GROUP_EDIT,
  JOURNEY_CAMPAIGN_GROUP_VIEW,
  PROJECT_EDIT,
  PROJECT_VIEW,
  SMART_CAMPAIGN_CREATE,
  SMART_CAMPAIGN_EDIT,
  SMART_CAMPAIGN_VIEW,
  TRIDENT_CAMPAIGN_CREATE,
  TRIDENT_CAMPAIGN_EDIT,
} = UCD_ROUTES_LINK;

const modelName = 'ucdCampaigns';

const views = {
  index: UCDHomePage,
  createSmartCommsCampaign: UCDCreateSmartCommsCampaign,
  editSmartCommsCampaign: UCDCreateSmartCommsCampaign,
  duplicateSmartCommsCampaign: UCDCreateSmartCommsCampaign,
  viewSmartCommsCampaign: UCDSmartCommsCampaignDetailPage,
  editProject: ProjectEditPage,
  duplicateProject: ProjectEditPage,
  viewProject: ProjectDetailPage,
  editCampaign: CampaignEditPage,
  duplicateCampaign: CampaignEditPage,
  viewCampaign: CampaignDetailPage,
  createTridentCampaign: CreateTridentCampaignPage,
  editTridentCampaign: EditTridentCampaignPage,
  createJourneyCampaign: CreateJourneyCampaignPage,
  editJourneyCampaignBuilder: CreateJourneyCampaignPage,
  editJourneyCampaign: JourneyCampaignEditPage,
  createJourneyCampaignGroup: CreateJourneyCampaignGroup,
  editJourneyCampaignGroup: EditJourneyCampaignGroup,
  viewJourneyCampaign: JourneyCampaignDetailPage,
  viewJourneyCampaignGroup: JourneyCampaignGroupViewPage,
};

const defaultUCDCampaign = {
  name: '',
};

const modelConfig: ModelConfig = {
  defaultEntity: () => defaultUCDCampaign,
  modelName,
  localeSelector,
  permissionKey,
  webPath,
  hasFieldsAccessFunc,
  stateKey: modelName,
  apiPath: '/ucd',
  allowCreation: true,
  allowDuplication: true,
  nameField: 'name',
  idField: 'projectID',
  hasDetailsHeader: true,
  views,
  routes: {
    editProject: PROJECT_EDIT(':entityID'),
    createSmartCommsCampaign: SMART_CAMPAIGN_CREATE(),
    editSmartCommsCampaign: SMART_CAMPAIGN_EDIT(':entityId', ':campaignId'),
    duplicateSmartCommsCampaign: '/ucd/project/:entityId/smart-comms/create', // SMART_CAMPAIGN_DUPLICATE provides additional query param so hardcoding the route value
    viewSmartCommsCampaign: SMART_CAMPAIGN_VIEW(':entityId', ':campaignId'),
    duplicateProject: '/ucd/project/new', // PROJECT_DUPLICATE provides additional query param so hardcoding the route value
    viewProject: PROJECT_VIEW(':entityID'),
    editCampaign: CAMPAIGN_EDIT(':entityID', ':campaignID'),
    duplicateCampaign: '/ucd/project/:entityID/campaign/new', // CAMPAIGN_DUPLICATE provides additional query param so hardcoding the route value
    viewCampaign: CAMPAIGN_VIEW(':entityID', ':campaignID'),
    viewJourneyCampaign: JOURNEY_CAMPAIGN_VIEW(':entityID', ':campaignID'),
    createTridentCampaign: TRIDENT_CAMPAIGN_CREATE(':entityID', ':campaignID'),
    editTridentCampaign: TRIDENT_CAMPAIGN_EDIT(':entityID', ':campaignID'),
    createJourneyCampaign: JOURNEY_CAMPAIGN_CREATE(
      ':entityID',
      ':campaignID',
      ':template',
    ),
    editJourneyCampaignBuilder: JOURNEY_CAMPAIGN_BUILDER_EDIT(
      ':entityID',
      ':campaignID',
    ),
    editJourneyCampaign: JOURNEY_CAMPAIGN_EDIT(':entityID', ':campaignID'),
    createJourneyCampaignGroup: JOURNEY_CAMPAIGN_GROUP_CREATE(),
    editJourneyCampaignGroup: JOURNEY_CAMPAIGN_GROUP_EDIT(':campaignGroupID'),
    viewJourneyCampaignGroup: JOURNEY_CAMPAIGN_GROUP_VIEW(':campaignGroupID'),
  },
};

export default modelConfig;
